// extracted by mini-css-extract-plugin
module.exports =  {"cardsContainer":"cardsContainer_cHUYgR3C","card":"card_YlesF4ed","iconWrapper":"iconWrapper_IXYsDWzb"};